import {
    type FC
} from "react";
import type IComposerSubmitProps from "./type";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    useComposerContext
} from "../../context";
import {
    warnOnce
} from "../../../../utils/development";
import {
    ComposerSubmitIcon
} from "../icons";
import Button from "../../../button";

const ComposerSubmit: FC<IComposerSubmitProps> = ({
    stopIcon = ComposerSubmitIcon,
    customTheme: customThemeProp,
    icon = ComposerSubmitIcon,
    stopTitle,
    title,
    style
}) => {
    const context = useComposerContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context?.customLocalize);

    if(!context) {
        warnOnce({
            message: "Composer.Submit: it must be rendered inside a Composer."
        });

        return null;
    }

    const {
        onSubmitPress,
        customTheme,
        isStreaming,
        onStopPress,
        buttonSize,
        isDisabled,
        canSubmit
    } = context;

    if(isStreaming) {
        return <Button
            accessibilityLabel={stopTitle ?? localize("stop-response")}
            customTheme={customThemeProp ?? customTheme}
            isDisabled={isDisabled || !onStopPress}
            onPress={onStopPress ?? onSubmitPress}
            size={buttonSize}
            variant="filled"
            icon={stopIcon}
            type="neutral"
            style={style}
        />;
    }

    return <Button
        accessibilityLabel={title ?? localize("send-message")}
        customTheme={customThemeProp ?? customTheme}
        isDisabled={isDisabled || !canSubmit}
        onPress={onSubmitPress}
        size={buttonSize}
        variant="filled"
        type="primary"
        style={style}
        icon={icon}
    />;
};
export default ComposerSubmit;
